export enum Currency {
    RUB = 'RUB',
    USD = 'USD',
    KZT = 'KZT',
}
